export default "__VITE_ASSET__AHBKf4g7__"